import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 78,
	height: 78,
	viewBox: "0 0 78 78",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 38.8243,
		cy: 38.8243,
		rx: 38.8243,
		ry: 38.8243,
		fill: "#425893"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M47.8581 42.6414L48.9584 35.6506H42.1806V31.1065C42.1806 29.195 43.1269 27.3271 46.1527 27.3271H49.2775V21.374C47.4577 21.0838 45.619 20.9268 43.7761 20.9043C38.1976 20.9043 34.5557 24.2577 34.5557 30.3201V35.6506H28.3721V42.6414H34.5557V59.5505H42.1806V42.6414H47.8581Z",
		fill: "white"
	})]
});
export default SvgFacebook;
